import { Row, Col, Typography } from "antd";

const { Text, Title } = Typography;

export default function TotalSummary({
  type = 0,
  subTotalMain = 0,
  totalPajakMain = 0,
  subTotalOther = 0,
  totalPajakOther = 0,
  totalAll = 0,
  totalPajak = 0,
  otherAmount = 0,
}) {
  let dpp = totalAll;
  let ppn = Math.round(totalPajak);
  let pph = 0; // PPh 23/4-2, user can adjust later
  let other = Number(otherAmount) || 0;
  let subTotal = 0;
  let totalCharge = dpp + ppn - pph + other;

  const fmt = (val) => `Rp ${val.toLocaleString("id-ID")}`;

  if (type === 1) {
    dpp = subTotalMain;
    ppn = Math.round(totalPajakMain);
    subTotal = dpp + ppn - pph + other;

    return (
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <div
            style={{
              padding: "10px 12px",
            }}
          >
            <Row justify="end" gutter={[0, 8]}>
              <Col xs={24} md={12}>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>DPP</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(dpp)}</Text>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>PPN</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(ppn)}</Text>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>Biaya Lain-lain</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(other)}</Text>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>Sub Total</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(subTotal)}</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }

  if (type === 2) {
    dpp = subTotalOther;
    ppn = Math.round(totalPajakOther);
    subTotal = dpp + ppn;

    return (
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <div
            style={{
              padding: "10px 12px",
            }}
          >
            <Row justify="end" gutter={[0, 8]}>
              <Col xs={24} md={12}>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>DPP</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(dpp)}</Text>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>PPN</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(ppn)}</Text>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>Sub Total</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(subTotal)}</Text>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }

  if (type === 3) {
    dpp =
      Number(subTotalMain) -
      Number(pph) +
      Number(otherAmount) +
      Number(subTotalOther);
    ppn = Math.round(totalPajakMain + totalPajakOther);
    totalCharge = dpp + ppn;

    return (
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <div
            style={{
              backgroundColor: "#FAFAFA",
              padding: "20px 24px",
              borderRadius: "8px",
              border: "1px solid #e8e8e8",
            }}
          >
            <Row justify="end" gutter={[0, 8]}>
              <Col xs={24} md={12}>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>DPP</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(dpp)}</Text>
                  </Col>
                </Row>
                <Row justify="space-between" style={{ marginBottom: 8 }}>
                  <Col>
                    <Text strong>PPN</Text>
                  </Col>
                  <Col>
                    <Text>{fmt(ppn)}</Text>
                  </Col>
                </Row>
                <div
                  style={{
                    borderTop: "2px solid #cf1322",
                    paddingTop: 8,
                    marginTop: 4,
                  }}
                >
                  <Row justify="space-between">
                    <Col>
                      <Title level={5} style={{ margin: 0, color: "#cf1322" }}>
                        TOTAL CHARGE
                      </Title>
                    </Col>
                    <Col>
                      <Title level={5} style={{ margin: 0, color: "#cf1322" }}>
                        {fmt(totalCharge)}
                      </Title>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <div
          style={{
            backgroundColor: "#FAFAFA",
            padding: "20px 24px",
            borderRadius: "8px",
            border: "1px solid #e8e8e8",
          }}
        >
          <Row justify="end" gutter={[0, 8]}>
            <Col xs={24} md={12}>
              <Row justify="space-between" style={{ marginBottom: 8 }}>
                <Col>
                  <Text strong>DPP</Text>
                </Col>
                <Col>
                  <Text>{fmt(dpp)}</Text>
                </Col>
              </Row>
              <Row justify="space-between" style={{ marginBottom: 8 }}>
                <Col>
                  <Text strong>PPN</Text>
                </Col>
                <Col>
                  <Text>{fmt(ppn)}</Text>
                </Col>
              </Row>
              <Row justify="space-between" style={{ marginBottom: 8 }}>
                <Col>
                  <Text strong>PPh (23/4-2)</Text>
                </Col>
                <Col>
                  <Text>{fmt(pph)}</Text>
                </Col>
              </Row>
              <Row justify="space-between" style={{ marginBottom: 8 }}>
                <Col>
                  <Text strong>Biaya Lain-lain</Text>
                </Col>
                <Col>
                  <Text>{fmt(other)}</Text>
                </Col>
              </Row>
              <div
                style={{
                  borderTop: "2px solid #cf1322",
                  paddingTop: 8,
                  marginTop: 4,
                }}
              >
                <Row justify="space-between">
                  <Col>
                    <Title level={5} style={{ margin: 0, color: "#cf1322" }}>
                      TOTAL CHARGE
                    </Title>
                  </Col>
                  <Col>
                    <Title level={5} style={{ margin: 0, color: "#cf1322" }}>
                      {fmt(totalCharge)}
                    </Title>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
}
